import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'code',
        title: i18n.t('label.code'),
        sortable: false,
        textAlign:'center'
    },
    {
        field: 'coupon_type',
        title: i18n.t('label.type'),
        sortable: true,
    }

]